<template>
  <!-- 抄表员管理 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="12">
          <div class="form-area">
            <div class="form-container">
              <a-col :md="4" :sm="12">
                <a-form-item label="姓名">
                  <a-input v-model="query.readerName" style="width: 200px" placeholder="" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="12">
                <a-form-item label="手机号码">
                  <a-input
                    v-model="query.phoneNumber"
                    style="width: 200px"
                    placeholder=""
                    allow-clear
                    @input="onPhoneInput"
                  />
                </a-form-item>
              </a-col>
            </div>

            <div class="button-container">
              <a-col :md="6" :sm="12" style="display: flex">
                <a-form-item>
                  <a-button type="primary" @click="queryList">查询</a-button>
                </a-form-item>
                <a-form-item style="margin-left: 12px">
                  <a-button @click="resetList">重置</a-button>
                </a-form-item>
                <a-form-item style="margin-left: 8px">
                  <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del
                    >删除</a-button
                  >
                </a-form-item>
                <a-form-item style="margin-left: 8px">
                  <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()" v-action:add
                    >新增</a-button
                  >
                </a-form-item>
                <a-form-item style="margin-left: 8px">
                  <a-button type="default" style="margin-left: 8px" @click="resetPasswordBatch" :disabled="!selectedRows || selectedRows.length === 0" v-action:edit>重置密码</a-button>
                </a-form-item>
              </a-col>
            </div>
          </div>
        </a-row>
      </a-form>
    </div>
    <a-table
      ref="table"
      rowKey="id"
      size="middle"
      bordered
      :columns="columns"
      :loading="dataListLoading"
      :dataSource="list"
      :pagination="pagination"
      :rowSelection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      @change="pageChange"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record)" v-action:edit> 编辑 </a>
      </span>
      <span slot="loginPerms" slot-scope="text, record"> 
            <a-switch :checked="record.loginPerms == 0 ? true : false" @change="onRevealChangeUpdate(record)" />
          </span>
    </a-table>

    <!-- 新增弹框 -->
    <a-modal
      :title="isUpdate ? '编辑抄表员' : '新增'"
      style="top: 20px"
      :width="800"
      v-model="addOrUpdateVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form class="tenant-form" :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="抄表员姓名:">
          <a-input
            placeholder="请输入姓名"
            style="width: 100%"
            v-decorator="['readerName', { rules: [{ required: true, message: '请输入姓名' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="性别：">
          <a-select
            placeholder="请选择性别"
            style="width: 100%"
             v-decorator="['gender', { rules: [{ required: true, message: '请选择性别！' }] }]"
          >
            <a-select-option value="1"> 男 </a-select-option>
            <a-select-option value="2"> 女 </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="手机号码">
          <a-input
            placeholder="请输入手机号码"
            style="width: 100%"
            v-decorator="[
              'phoneNumber',
              {
                rules: [
                  { required: true, message: '请输入手机号码' },
                  { pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '请输入正确的手机号码!' },
                ],
              },
            ]"
          />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="家庭地址">
          <a-input
            placeholder="请输入家庭地址"
            style="width: 100%"
            v-decorator="['homeAddress', { rules: [{ required: true, message: '请输入家庭地址' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单位名称">
          <a-input
            placeholder="请输入单位名称"
            style="width: 100%"
            v-decorator="['unitName', { rules: [{ required: true, message: '请输入单位名称' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开启状态：">
          <a-switch
            v-decorator="['loginPerms', { valuePropName: 'checked', initialValue: true }]"
            checked-children="开启"
            un-checked-children="关闭"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'

export default {
  name: 'PointCheck',
  mixins: [mixinViewModule],
  data() {
    return {
      queryUrl: '/meter-manager/meter_readers/page',
      queryOneUrl: '/pipe-network/meter_reading_staffs', 
      addOrUpdateUrl: '/meter-manager/meter_readers/save', // 新增或更新数据
      deleteUrl: '/meter-manager/meter_readers/batch/', // 删除数据
      recycleBinVisible: false,
      selectedRowKeys: [],   
      query: {
        readerName: '',
        phoneNumber: '',
      },
      userId: '',
      userName: '',
      columns: [
        {title: '序号',dataIndex: '',key: 'rowIndex',width: 70,customRender: function (t, r, index) { return parseInt(index) + 1},},
        {title: '姓名',dataIndex: 'readerName',width: 120,},
        {title: '性别',dataIndex: 'gender',width: 80,customRender: (text) => {return text === 1 ? '男' : '女'},},
        {title: '手机号码',dataIndex: 'phoneNumber',width: 150,},
         {title: '家庭地址',dataIndex: 'homeAddress',width: 220,},
        {title: '单位名称',dataIndex: 'unitName',width: 100,},
        {title: '开启状态',dataIndex: 'loginPerms',width: 100,scopedSlots: { customRender: 'loginPerms' }},
        {title: '登录状态',dataIndex: 'loginStatus',width: 100,customRender: (text) => {return text === 1 ? '在线' : '离线'},},
        {title: '登录次数',dataIndex: 'loginCount',width: 100,},
        {title: '最新登录时间',dataIndex: 'lastLoginTime',width: 100,},
        {title: '添加时间',dataIndex: 'createTime',width: 200,},
        { title: '操作', align: 'center', dataIndex: 'action', width: 100, scopedSlots: { customRender: 'action' } },
      ],
   
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
    }
  },
  computed: {
 
    token() {
      return this.$store.getters.token
    },
  },
  created() {
    this.queryList()
  },
  methods: {
    //登录状态颜色变化
    getStatusColor(text) {
      const colorMap = {
        '在线': '#07d506',
        '离线': '#c3c3c3',
      };
      return colorMap[text] || '#d9d9d9';
    },
    // 删除
    deleteSelectRow() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning('请选择要删除的记录')
        return
      }
      this.$confirm({
        title: '提示',
        content: '确定要删除选中的记录吗？',
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          
          this.$http.delete(`${this.deleteUrl}`,{ data: this.selectedRows }).then(({ code }) => {
            if (code === 0) {
              this.$message.success('删除成功')
              this.selectedRows = []
              this.queryList()
            }
          })
        }
      })
    },

    // 新增或编辑
    addOrUpdateHandle(data) {
      this.isUpdate = false
      this.addOrUpdateForm.resetFields()
      if (data) {
        // 编辑
        this.currentId = data.id

        this.isUpdate = true
        this.$nextTick(() => {
          this.addOrUpdateForm.setFieldsValue({
            readerName: data.readerName,
            gender: String(data.gender),             
            phoneNumber: data.phoneNumber,
            homeAddress: data.homeAddress,
            unitName: data.unitName,
            loginPerms: data.loginPerms === 0
          })
        })
      } else {
        // 新增时设置性别默认值为男，开启状态默认为开启
        this.$nextTick(() => {
          this.addOrUpdateForm.setFieldsValue({
            gender: '1',
            loginPerms: true
          })
        })
      }
      this.addOrUpdateVisible = true
    },

    // 新增
    handleOk() {
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) { 
          let data
          const header = {
            'Content-Type': 'application/json',
            Authorization: this.token,
          }
          let method
          let message
          if (this.isUpdate == false) {
            method = 'post'
            message = '新增成功'
            data = {
              readerName: values.readerName,
              gender: values.gender,
              phoneNumber: values.phoneNumber,
              unitName: values.unitName,
              homeAddress: values.homeAddress,
              loginPerms: values.loginPerms ? 0 : 1
             }
          } else {
            method = 'put'
            message = '修改成功'
            data = {
              id: this.currentId,
              readerName: values.readerName,
              gender: values.gender,
              phoneNumber: values.phoneNumber,
              unitName: values.unitName,
              homeAddress: values.homeAddress,
              loginPerms: values.loginPerms ? 0 : 1
             }
          }
          this.$http({
            url: this.addOrUpdateUrl,
            data: data,
            method: method,
            headers: header,
          }).then((resolve) => {
            console.log('resolve',resolve);
            
            if (resolve.code === 0) {
              console.log(resolve)
              this.$message.success(message)
              this.addOrUpdateVisible = false
              this.queryList()
              this.currentId = ''
            } else {
              this.$message.error(resolve.message || '操作失败')
            }
          }).catch((error) => {
            // console.error('请求失败:', error)
            // this.$message.error('操作失败，请稍后重试')
          })
        }
      })
    },

    // 开启状态切换
    onRevealChangeUpdate(record) {
      const newStatus = record.loginPerms === 0 ? 1 : 0
      const statusText = newStatus === 0 ? '开启' : '关闭'
      
      this.$confirm({
        title: '提示',
        content: `确定要${statusText}该抄表员的登录权限吗？`,
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          const data = {
            id: record.id,
            readerName: record.readerName,
            gender: record.gender,
            phoneNumber: record.phoneNumber,
            unitName: record.unitName,
            homeAddress: record.homeAddress,
            loginPerms: newStatus
          }
          
          this.$http({
            url: this.addOrUpdateUrl,
            data: data,
            method: 'put',
            headers: {
              'Content-Type': 'application/json',
              Authorization: this.token,
            },
          }).then((resolve) => {
            if (resolve.code === 0) {
              this.$message.success(`${statusText}成功`)
              this.queryList()
            } else {
              this.$message.error(resolve.message || `${statusText}失败`)
            }
          }).catch((error) => {
            // console.error('请求失败:', error)
            // this.$message.error(`${statusText}失败，请稍后重试`)
          })
        }
      })
    },
    // 批量重置密码
    resetPasswordBatch() { 
      
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning('请选择要重置密码的记录')
        return
      }
      this.$confirm({
        title: '提示',
        content: '确定要重置选中抄表员的密码吗？',
        okText: '确定',
        cancelText: '取消',
        onOk: () => { 
          this.$http.post('/meter-manager/meter_readers/reset', this.selectedRows, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: this.token,
            },
          }).then((res) => {
            if (res.code === 0) {
              this.$message.success('重置成功')
              this.selectedRows = []
            } else {
              this.$message.error(res.message || '重置失败')
            }
          }).catch(() => {
            this.$message.error('重置失败')
          })
        }
      })
    }, 
    // 手机号输入时校验
    onPhoneInput(e) {
      let value = e.target.value.replace(/\D/g, '')
      if (value.length > 11) {
        value = value.slice(0, 11)
        this.$message.warning('手机号最多11位')
      }
      if (value !== this.query.phoneNumber) {
        this.query.phoneNumber = value
      }
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}

.form-area {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.form-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.button-container {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.status-tag {
  width: 80px;
  text-align: center;
  font-weight: 500;
  border-radius: 4px;
  color: white !important;
}
</style>
